import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import NumerologyAccessGate from './NumerologyAccessGate';
import NumerologyShellChrome from './NumerologyShellChrome';

/** Legacy URLs outside `/numerology/*` that redirect in — gate runs before Navigate. */
export default function NumerologyLegacyAccessRedirect({ to }) {
  const { search } = useLocation();
  return (
    <NumerologyShellChrome>
      <NumerologyAccessGate>
        <Navigate to={`${to}${search}`} replace />
      </NumerologyAccessGate>
    </NumerologyShellChrome>
  );
}
